/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoutingMenuItemModel} from '../shared/utils/routing-menu-item.model';
import {ClaimCreateNewComponent} from './claim-create-new/claim-create-new.component';
import {PermissionsGuard} from '../permissions.guard';
import {Permission} from '../shared/utils/permission.enum';
import {ClaimMainPageComponent} from './claim-main-page/claim-main-page.component';
import {ClaimDetailPageComponent} from './claim-detail-page/claim-detail-page.component';
import {ClaimDetailResolver} from './services/claim-detail/claim-detail.resolver.service';
import {ClaimEditPageComponent} from './claim-edit-page/claim-edit-page.component';
import {EditGuard} from './claim-edit-page/guard/edit.guard';
import {ClaimAttachmentsPageComponent} from './claim-attachments-page/claim-attachments-page.component';
import {ClaimAttachmentsResolver} from './claim-attachments-page/resolver/claim-attachments.resolver.service';
import {UnsavedChangesGuard} from '../shared/guards/unsaved-work/unsaved-changes.guard';

export const routes: Routes = [
    {
        path: 'claim',
        canActivate: [PermissionsGuard],
        canActivateChild: [PermissionsGuard],
        data: {
            hasSideBarMenu: true,
            breadcrumb: 'Claim',
            permissions: [Permission.PARTNER_CLAIM_VIEW, Permission.ADMIN_CLAIM_VIEW],
            menuItem: {
                label: 'Claim',
                icon: 'iwp-icon-gen_claims',
                index: 2
            } as RoutingMenuItemModel
        },
        children: [
            {
                path: '',
                component: ClaimMainPageComponent,
                data: {
                    hasSideBarMenu: true,
                    hasStickyHeader: true,
                    permissions: [Permission.PARTNER_CLAIM_VIEW, Permission.ADMIN_CLAIM_VIEW],
                    menuItem: {
                        label: 'View list'
                    } as RoutingMenuItemModel
                }
            },
            {
                path: 'new',
                component: ClaimCreateNewComponent,
                canDeactivate: [UnsavedChangesGuard],
                data: {
                    hasSideBarMenu: true,
                    breadcrumb: 'Create new Claim',
                    permissions: [Permission.PARTNER_CLAIM_CREATE],
                    menuItem: {
                        label: 'New',
                        index: 1
                    } as RoutingMenuItemModel
                }
            },
            {
                path: ':claimNumber',
                data: {
                    breadcrumb: 'Claim :claimNumber'
                },
                children: [
                    {
                        path: '',
                        component: ClaimDetailPageComponent,
                        resolve: {claimDetail: ClaimDetailResolver},
                        runGuardsAndResolvers: 'always',
                        data: {
                            hasSideBarMenu: true,
                            hasStickyHeader: true,
                            permissions: [Permission.PARTNER_CLAIM_VIEW, Permission.ADMIN_CLAIM_VIEW]
                        }
                    },
                    {
                        path: 'edit',
                        component: ClaimEditPageComponent,
                        canActivate: [EditGuard],
                        canDeactivate: [UnsavedChangesGuard],
                        resolve: {claimDetail: ClaimDetailResolver},
                        data: {
                            hasSideBarMenu: true,
                            breadcrumb: 'Edit',
                            permissions: [Permission.PARTNER_CLAIM_EDIT]
                        }
                    }
                ]
            }
        ]
    },
    {
        path: 'claim/:claimNumber/files',
        component: ClaimAttachmentsPageComponent,
        canActivate: [PermissionsGuard],
        resolve: {claimBase: ClaimAttachmentsResolver},
        data: {
            hideBreadcrumbs: true,
            permissions: [Permission.ADMIN_CLAIM_VIEW_BASE]
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ClaimRoutingModule {
}
